const fontSize = {
  h1: '36px',
  h2: '30px',
  h3: '26px',
  h4: '22px',
  h5: '18px',
  desc: '16px',
  default: '15px',
  small: '13px',
}

const fontWeight = {
  extraBold: 800,
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
  light: 300,
}

const deviceSize = {
  mobile: '(max-width: 1079px)',
  desktop: '(min-width: 1080px)',
  mediumDesktop: '(min-width: 1080px) and (max-width: 1319px)',
  largeDesktop: '(min-width: 1320px)',
}

const color = {
  primary: '#24D59E',
  primary2: '#B4EDD4',
  primary3: '#E0F8EE',
  primary4: '#006b35',
  primary5: '#009D59',
  primary6: '#F4FFF7',
  primary7: '#749592',
  primary8: '#006C4D',
  primary9: '#7DE1B9',
  primary10: '#00C28E',
  primary11: '#00513A',
  secondary: '#1F8FF0',
  secondary2: '#E4F3FE',
  alert: '#DC362E',
  linear: 'linear-gradient(90deg, #24D59E 29.36%, #2CCFC3 50%)',
  black1: '#002115',
  black2: '#444444',
  black3: '#747470',
  black4: '#79747E',
  gray1: '#888888',
  gray2: '#A9ABB1',
  gray3: '#E4E4E4',
  gray4: '#D9D9D9',
  gray5: '#E0E0DB',
  white1: '#FFFFFF',
  white2: '#FEFEFE',
  background: '#F8F8F8',
  background2: '#F5F5F0',
  background3: '#FAFAFA',
  background4: '#E9EFF0',
  background5: '#F0F0F0',
  line: '#E9E9E9',
  gold: '#FDD000',
  orange: '#FF8B64',
  blue: '#5365B6',
  red: '#F4686D',
  green: '#009B2D',
  lightGreen: '#00BF72',
  highlight: '#fff3bb',
}

export const theme = {
  fontSize,
  fontWeight,
  deviceSize,
  color,
}

export type ThemeType = typeof theme
